import FormElementSync from "./form-element-sync";
import Helpers from "./helpers";
import SelectorFilter from "./selector-filter";

declare var $: any;
declare var Stickyfill: any;

export default class ProductPage {

	private productPageElement = document.querySelector('.c-product-page') as HTMLElement;
	private stickyElement = document.querySelector('.js-product-page-sticky-element') as HTMLElement;
	private formElement = document.querySelector('.js-product-page-form') as HTMLFormElement;
	private addButton = document.querySelector('.js-product-page-add') as HTMLButtonElement;
	private stickyButton = document.querySelector('.js-product-page-sticky-element-button') as HTMLButtonElement;
	private stickyPollyfillInit = false;
	private leadGallery: any;
	private floaterGallery: any;
	private galleryLoadedCssClass = "has-loaded";
	private isFirstTime = true;

	constructor() {
		this.init();
	}

	public init() {
		if (!this.productPageElement) return;
		this.initGallery();
		if (this.stickyElement) {
			this.stickyPollyfill();
			this.stickyFloaterEvents();
		}
		this.variantSync();
		this.mobileSetup();
		this.getDeliveryEstimate();
		this.isFirstTime = false;
		this.setQuantityIfParamPresent();
	}

	public getDeliveryEstimate() {
		if (this.isFirstTime) {
			(<any>window).deliveryEstimate.getEstimate($('#productId').val());
		}
	}

	public setQuantityIfParamPresent() {
		const quantityQueryParameter = Helpers.getParameter('quantity');
		if (quantityQueryParameter) {
			const quantityElement = document.querySelector('.js-quantity-captured') as HTMLSelectElement;
			if (quantityElement) {
				quantityElement.value = quantityQueryParameter;
			}	
		}
	}

	public initGallery() {

		const $leadGalleryElement = $('[data-gibe-gallery="product"]');
		const $floaterGalleryElement = $('[data-gibe-gallery="product|floater"]');

		if (!$leadGalleryElement.hasClass(this.galleryLoadedCssClass)) {
			$leadGalleryElement.addClass(this.galleryLoadedCssClass);
			this.leadGallery = $leadGalleryElement.gibeGallery({
				launch: 980,
				linksActiveClass: 'c-gallery__link--active',
				transition: 'slide',
				forceSquare: true,
				horizontal: {
					width: 1,
					height: 1
				},
				stage: '[data-gibe-gallery-stage="product"]',
				onStageChange: (index)=> {
					if (document.querySelector('[data-gibe-gallery="product|floater"]')) {
						this.floaterGallery.stage.transition.go(index);
					}
				}
			});
			
		}

		if (!$floaterGalleryElement.hasClass(this.galleryLoadedCssClass)) {
			$floaterGalleryElement.addClass(this.galleryLoadedCssClass);
			this.floaterGallery = $floaterGalleryElement.gibeGallery({
				launch: 980,
				linksActiveClass: 'c-gallery__link--active',
				transition: 'slide',
				forceSquare: true,
				horizontal: {
					width: 1,
					height: 1
				},
				stage: '[data-gibe-gallery-stage="product|floater"]',
				onStageChange: (index)=> { this.leadGallery.stage.transition.go(index); }
			});
			
		}

	}

	private stickyPollyfill() {

		const self = this;

		if (this.stickyPollyfillInit) return;

		this.stickyPollyfillInit = true;

		//@ts-ignore
		const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

		if (!isIE11 || !this.stickyElement) return;

		(function () {
			const s = document.createElement('script');
			s.type = 'text/javascript';
			s.src = '/js/stickyfill.js';
			(document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(s);
		})();

		const checkInterval = setInterval(()=> {

			if (Stickyfill !== undefined) {

				Stickyfill.add(self.stickyElement);
				clearInterval(checkInterval);

			}

		}, 500);
	}

	private stickyFloaterEvents() {

		document.addEventListener('click', (e) => {

			const target = e.target as HTMLElement;

			if (target && target.classList.contains('js-product-page-sticky-element-button')) {

				e.preventDefault();
				e.stopPropagation();

				this.addButton.click();

				if (!this.formElement.querySelector('.field-validation-error')) return;

				this.formElement.scrollIntoView({ behavior: 'smooth' });
			}

		});


	}

	private variantSync() {

		const elements = SelectorFilter.excludeByClass(document.querySelectorAll('.js-product-page-variant-item'),'js-product-page-variant-item-done');

		if (!elements.length) { return; }

		for (let i = 0; i < elements.length; i++) {

			(function () {
				let index = i;
				let select = elements[index].querySelectorAll('.js-product-page-variant-item-select');
				let radios = elements[index].querySelectorAll('.js-product-page-variant-item-radio');

				if (select.length && radios.length) { new FormElementSync(select, radios); }


				elements[index].classList.add('js-product-page-variant-item-done');
			})();

		}
	}

	private mobileSetup() {

		if (matchMedia('(max-width: 540px)').matches) {
			// open accordions
			const accordionTriggers = document.querySelectorAll('.c-accordion .js-slide-toggle[aria-expanded="true"]');
			for (let i = 0; i < accordionTriggers.length; i++) {
				const currentTrigger = accordionTriggers[i];
				currentTrigger.setAttribute('aria-expanded', 'false');
				const ariaControls = currentTrigger.getAttribute('aria-controls');
				const target = document.querySelector('#' + ariaControls) as HTMLElement;
				target.style.height = '0px';
				target.setAttribute('aria-hidden', 'true');
			}

			// open reveals and remove them
			const revealContentElements = document.querySelectorAll('.c-accordion .js-reveal-content') as NodeListOf<HTMLElement>;
			for (let j = 0; j < revealContentElements.length; j++) {
				revealContentElements[j].style.maxHeight = "none";
				revealContentElements[j].classList.remove('c-reveal--active');
				revealContentElements[j].classList.add('c-reveal--open');
				const revealButton = revealContentElements[j].querySelector('.c-reveal__button') as HTMLButtonElement;
				if (revealButton) {
					revealButton.style.display = 'none';
				}

			}
		}
	}

};

